import React from "react";
import type { NextPage } from "next";
import { ContainerWhite, TextCenter } from "../components/basic";
import { cards } from "../lib/cards";
import { Card } from "../components/card";

const Karticky: NextPage = () => (
	<ContainerWhite>
		<TextCenter>
			<h1>Seznam kartiček</h1>
		</TextCenter>
		{cards.map((card) => (
			<Card card={card} key={card.id} />
		))}
	</ContainerWhite>
);

export default Karticky;
